export default "__VITE_ASSET__5d5iQwPf__"